// Auth Service - OOP Business Logic
import { AuthRepository } from '../repositories/AuthRepository';
import { IUser, IAuthResponse } from '../interfaces/IUser';
import { LoginDto, RegisterDto, ForgotPasswordDto, ResetPasswordDto, AcceptInviteDto } from '../dto/AuthDto';

export class AuthService {
  constructor(private authRepository: AuthRepository) {}

  async login(dto: LoginDto): Promise<IAuthResponse> {
    const response = await this.authRepository.login(dto);
    return response;
  }

  async register(dto: RegisterDto): Promise<IAuthResponse> {
    const response = await this.authRepository.register(dto);
    return response;
  }

  async forgotPassword(dto: ForgotPasswordDto): Promise<{ message: string }> {
    return this.authRepository.forgotPassword(dto);
  }

  async resetPassword(dto: ResetPasswordDto): Promise<{ message: string }> {
    return this.authRepository.resetPassword(dto);
  }

  async acceptInvite(dto: AcceptInviteDto): Promise<{ message: string }> {
    return this.authRepository.acceptInvite(dto);
  }

  async getCurrentUser(): Promise<IUser> {
    return this.authRepository.getCurrentUser();
  }

  hasRole(user: IUser, role: string): boolean {
    return user.roles.some((r) => r === role);
  }

  hasPermission(user: IUser, roles: string[]): boolean {
    return roles.some((role) => this.hasRole(user, role));
  }
}
